var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopRightBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5H16.25C20.3921 0.5 23.75 3.85786 23.75 8V23.5H0.75V0.5Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5H16.25C20.3921 0.5 23.75 3.85786 23.75 8V23.5H0.75V0.5Z",
    stroke: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9691 5.2803C19.1842 5.49537 19.2445 5.76364 19.2574 6.01724C19.2694 6.2517 19.2429 6.54301 19.2131 6.87082L19.1412 7.66087C19.0907 8.21699 19.0484 8.68295 18.9666 9.02461C18.8848 9.36644 18.7267 9.74649 18.3163 9.89512C17.9059 10.0437 17.5411 9.85289 17.2594 9.64271C16.9918 9.44292 16.6796 9.13404 16.3102 8.76479L12.2354 12.8396C12.0076 13.0673 11.6383 13.0673 11.4105 12.8396C11.1827 12.6118 11.1827 12.2424 11.4105 12.0146L15.4852 7.93984C15.1157 7.57019 14.8066 7.25778 14.6067 6.98994C14.3965 6.70828 14.2057 6.34353 14.3543 5.93311C14.5029 5.52268 14.883 5.36461 15.2248 5.28281C15.5665 5.20103 16.0324 5.15869 16.5885 5.10816L17.3786 5.03634C17.7064 5.00651 17.9977 4.98 18.2322 4.99195C18.4858 5.00487 18.754 5.06523 18.9691 5.2803Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightBorder);
export default __webpack_public_path__ + "static/media/TopRightBorder.8655a4b922f06b8bc5cbfdf448b2b488.svg";
export { ForwardRef as ReactComponent };